import clsx from 'clsx'

let SmileIcon = ({ className }: { className?: string }) => (
  <svg
    className={clsx(className)}
    width='118'
    height='118'
    viewBox='0 0 118 118'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M34.4165 49.1665C36.3586 46.7819 39.0136 45.4298 41.7915 45.4298C44.5694 45.4298 47.1507 46.7819 49.1665 49.1665'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M68.8335 49.1665C70.7756 46.7819 73.4306 45.4298 76.2085 45.4298C78.9864 45.4298 81.5677 46.7819 83.5835 49.1665'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M90.2899 27.7105C107.571 44.9912 107.571 73.0088 90.2899 90.2894C73.0092 107.57 44.9916 107.57 27.711 90.2894C10.4303 73.0087 10.4303 44.9911 27.711 27.7105C44.9917 10.4298 73.0093 10.4298 90.2899 27.7105'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M76.2082 72.2158C76.2082 72.2158 69.7526 78.6665 58.9998 78.6665C48.2422 78.6665 41.7915 72.2158 41.7915 72.2158'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export default SmileIcon
